import React from "react";
import { useParams } from "react-router-dom-v5-compat";
import MealPlanView from "../../components/MealPlan/View";

export const MealPlanPage = () => {
  const { mealPlanId: maybeMealPlanId } = useParams();
  const mealPlanId = maybeMealPlanId || "";
  return <MealPlanView mealPlanId={mealPlanId} />;
};
